import _ from "lodash";
import Indicador from "..";
import VCCEditFields from "./components/VCCEditFields";
import { VCCParamFields } from "./components/VCCParamFields";
import vccReport from "./reports";
import vccReportSummary from "./reports/summary";

export default class VCC extends Indicador {
    static get fullName() {
        return "Vazão de Calda Cobridor";
    }

    static get abbrev() {
        return "VCC";
    }

    static get multTipo() {
        return true
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraVCC: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",
            turno: "turno",

            insumo: "insumo",
            variedade: "variedade",
            dosagemRecomendadaVCC: "dosagemRecomendada",

            ColetasVCC: {
                type: Array,
                newField: "coletas",
                children: {
                    pesagemVCC: "pesagem",
                    observacaoColetaVCC: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            afericao: "afericao",
            media: "media",
            doseMetroLinear: "doseMetroLinear",

            observacaoAmostraVCC: "observacao",

            itensColetaVCC: "images",
        };
    }

    static get legacyParamMap() {
        return {
            intervaloAderenciaMinimoManual: "manual.intervaloMin",
            intervaloAderenciaMaximoManual: "manual.intervaloMax",
            vazaoCaldaCobridorMetrosLinearesAmostraManual: "manual.metrosLinearesAmostra",
            vazaoCaldaCobridorMetrosLinearesHectareManual: "manual.metrosLinearesHectare",
            metaVCCManual: "manual.meta",

            intervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            intervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            vazaoCaldaCobridorMetrosLinearesAmostraMecanizado: "mecanizado.metrosLinearesAmostra",
            vazaoCaldaCobridorMetrosLinearesHectareMecanizado: "mecanizado.metrosLinearesHectare",
            metaVCCMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <VCCParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <VCCEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return vccReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return vccReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumPesagem = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                sumPesagem += f(coleta.pesagem);
            }
        }

        apontamento.media = sumPesagem / total;
        apontamento.media = apontamento.media.toFixed(4);

        // Dose por metro linear média das coletas.
        apontamento.doseMetroLinear = apontamento.media / f(params.metrosLinearesAmostra);
        apontamento.doseMetroLinear = apontamento.doseMetroLinear.toFixed(4);

        apontamento.afericao = apontamento.doseMetroLinear * f(params.metrosLinearesHectare);
        apontamento.afericao = apontamento.afericao.toFixed(4);

        const dosagemRecomendada = f(apontamento.dosagemRecomendada)

        if (!_.isNaN(dosagemRecomendada)) {
            const rawConformidade = (apontamento.afericao / f(apontamento.dosagemRecomendada)) * 100;
            apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
            apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
            let conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;

            return Math.abs(conformidade).toFixed(2);
        } else {
            apontamento.acima = 0;
            apontamento.abaixo = 0;
            return 0;
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 94.73, 100, 103.15);
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            { title: "Dose/Metro Linear", width: 'auto', getValue: (a) => parseFloat(a.doseMetroLinear).toFixed(2) },
            { title: "Média Aferição", width: 'auto', getValue: (a) => parseFloat(a.afericao).toFixed(2) },
            { title: "Dose Real", width: 'auto', getValue: (a) => parseFloat(a.media).toFixed(2) },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return "Dose/Metro Linear: " + parseFloat(apontamento.doseMetroLinear).toFixed(2) +
            ", Média Aferição: " + parseFloat(apontamento.afericao).toFixed(2) +
            " e Dose Real: " + parseFloat(apontamento.media).toFixed(2)
    }
}
